import isEmpty from 'lodash/isEmpty';

import React from 'react';

import FilterResetButton from '../FilterResetButton';
import FilterTitle from '../FilterTitle';

/**
 * FilterItem
 *
 * A list item component to handle filtering for book formats, author last initial
 *
 * @param {Object} props
 * @param {Object} props.setStart
 * @param {string} props.dataCode
 * @param {string} props.title
 * @param {Object} props.scrollToTop
 */
const FilterItem = ({ data, setStart, dataCode, title, scrollToTop, isActive, setIsActive, checked, setChecked, handleFilter }) => {
  const checkForStr = ( type ) => typeof ( type ) === 'string';

  const getCheckedState = ( item ) => {
    if ( isEmpty( checked ) ) return '';
    return checkForStr( item ) ? checked[item.toLowerCase()] : checked[item.value.toLowerCase()];
  };

  const filterTitleClickHandler = () => {
    setIsActive( cur => !cur );
  };

  return (
    <li className={ `filters__list-item text-[#121212] ${isActive ? 'is-active' : 'is-inactive'}` }>
      <FilterTitle title={ title } classes={ `${isActive ? 'mt-0 mb-10' : ''}` } onClick={ filterTitleClickHandler } />
      <ul className={ `filters__submenu w-full text-14 text-left flex flex-col gap-15 list-none mb-20 ml-0 pl-0 ${data?.length > 7 ? 'lg:h-[267px] lg:overflow-y-scroll' : 'lg:h-auto'}` }>
        { data.map( ( item, index ) => (
          <li
            className="submenu__list-item mb-0"
            key={ self.crypto.randomUUID() }
          >
            <input
              className='submenu__input mr-10 hidden'
              id={ checkForStr( item ) ? item.toLowerCase() : item.value?.toLowerCase() }
              type="checkbox"
              name={ checkForStr( item ) ? item.toLowerCase() : item.value?.toLowerCase() }
              value={ checkForStr( item ) ? item.toLowerCase() : item.value?.toLowerCase() }
              onChange={ ( e ) => handleFilter( e, index ) }
              checked={ getCheckedState( item ) }
            />
            <label className='submenu__input-label cursor-pointer relative flex items-center pl-33' htmlFor={ checkForStr( item ) ? item.toLowerCase() : item.value?.toLowerCase() }>
              <span dangerouslySetInnerHTML={{ __html: checkForStr( item ) ? item : item.label }} />
            </label>
          </li>
        ) ) }
      </ul>
      <FilterResetButton setStart={ setStart } checked={ checked } setChecked={ setChecked } dataFilter={ dataCode } scrollToTop={ scrollToTop } />
    </li>
  );
};

export default FilterItem;
